import React from 'react';
import PropTypes from 'prop-types';

export default function Day({ data, children }) {
  if (!data.isDate) return <td className='ec-week-day-blank'>&nbsp;</td>;

  let className = `ec-week-day ec-week-day-${data.label}`;

  if (data.isCurrentDate) {
    className += ` ec-week-day-current`;
  }

  if (data.isSelectedDate) {
    className += ` ec-week-day-selected`;
  }

  return (
    <td className={className}>
      <div className='ec-week-day-container'>
        <div className='ec-week-day-label'>{data.label}</div>
        {children}
      </div>
    </td>
  );
}

const DataShape = {
  id: PropTypes.string,
  isDate: PropTypes.bool,
  isCurrentDate: PropTypes.bool,
  isSelectedDate: PropTypes.bool,
  date: PropTypes.string,
  label: PropTypes.number,
  total: PropTypes.number,
  showMore: PropTypes.bool,
  showMoreRemaining: PropTypes.number,
  isCount: PropTypes.bool,
};

Day.propTypes = {
  data: PropTypes.shape(DataShape).isRequired,
  children: PropTypes.node.isRequired,
};
